import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import { Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { CustomButton } from '../../common/custom-button/customButton';
import { Box, Stack } from '@mui/system';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { ADD_BULK_STAKEHOLDER, CALCULATE_MBR, GET_ANNUAL_MBR, GET_APPROVED_STAKEHOLDERS, GET_MONTHLY_MBR, SAVE_ADVANCE_PAYMENT, SAVE_ANNUAL_MBR, UPDATE_MONTHLY_MBR } from '../../common/URLs';

import { loaderService } from '../../common/custom-loader/loader-service';
import { toast } from 'react-toastify';
import { userData } from '../../common/spinLoader';
import UploadIcon from '@mui/icons-material/Upload';
import { DataGrid, GridEditInputCell, GridToolbarQuickFilter, GridToolbarExport, GridCellEditStopReasons, useGridApiContext } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import { DEMAND_CONSTANTS, DEMAND_ROLES, PROD } from '../../common/constants';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { styled } from '@mui/material/styles';
import { DEMAND_VALIDATIONS } from '../../common/commonValidations';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { CalculateIcon, EditIcon, SaveIcon } from '../../common/icons';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import apiClient from '../../axios';

export const ManageMbr = () => {
  const [arrTemp, setArrTemp] = useState([]);
  const uuid = localStorage.getItem('uuid');
  const [saveAnnualMBRTemp, setSaveAnnualMBRTemp] = useState([]);
  const userLoggedIn = userData.user.userRoles?.[0].roleName
  const [selectedFinancialYear, setSelectedFinancialYear] = useState();
  const [combinedFinalMbrData, setCombinedFinalMbrData] = useState([]);
  const [isCalculateMbrBtnDisable, setIsCalculateMbrBtnDisable] = useState(true);
  const [isAddMbrBtnDisabled, setIsAddMbrBtnDisabled] = useState(true);
  const [updateMbrData, setUpdateMbrData] = useState([]);
  const [stakeholderCommonData, setStakeholderCommonData] = React.useState([]);
  const [editUpdateBtnName, setEditUpdateBtnName] = useState('Edit Monthly MBR');
  const [showBtnOnEditMonths, setShowBtnOnEditMonths] = useState(true);
  const [showMonthlyMbrBtn, setShowMonthlyMbrBtn] = useState(true);
  const [showSaveMbrBtn, setShowSaveMbrBtn] = useState(true);
  const [pageSize, setPageSize] = React.useState(10);
  const [isMbrEditable, setIsMbrEditable] = useState(false);

  const [calculateMonthlyMbrDialog, setCalculateMonthlyMbrDialog] = useState(false);
  const handleCalculateMonthlyMbrDialogOpen = () => setCalculateMonthlyMbrDialog(true);
  const handleCalculateMonthlyMbrDialogClose = () => setCalculateMonthlyMbrDialog(false);
  const [saveMonthlyMbrDialog, setSaveMonthlyMbrDialog] = useState(false);
  const handleSaveMonthlyMbrDialogOpen = () => setSaveMonthlyMbrDialog(true);
  const handleSaveMonthlyMbrDialogClose = () => setSaveMonthlyMbrDialog(false);

  const StyledBox = styled(Box)(({ theme }) => ({
    height: "inherit",
    width: '100%',
    '& .MuiDataGrid-cell--editing': {
      backgroundColor: 'rgb(255,215,115, 0.19)',
      color: '#1a3e72',
      '& .MuiInputBase-root': {
        height: '100%',
      },
    },
    '& .Mui-error': {
      backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
      color: theme.palette.error.main,
    },
  }));

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
  }));

    function EditInputCell(props) {
          const { error, id, value: valueProp, field } = props;
          const [value, setValue] = useState(valueProp);
          const apiRef = useGridApiContext();
  
          const handleChange = (event) => {
              const newValue = event.target.value; 
              apiRef.current.setEditCellValue({ id, field, value: newValue });
              setValue(newValue);
          };
  
          useEffect(() => {
              setValue(valueProp);
          }, [valueProp]);
          
          return (
              <StyledTooltip open={!!error} title={error}>
                  <GridEditInputCell {...props} value={value} onChange={handleChange} />
             </StyledTooltip>
          );
      }

  function renderEdit(params) {
    return <EditInputCell {...params} />;
  }

  const columns = [
    { field: 'stakeholderUrn', headerName: 'URN', width: 190 },
    { field: 'stakeholderType', headerName: 'Type' },
    {
      field: 'stakeholderMbr', headerName: 'Annual MBR(in MT)', editable: true,
      width: 190,
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'stakeholderRemainingMBR', headerName: 'Remaining MBR(in MT)',
      headerClassName: 'super-app-theme--header',
      width: 190,
    },
    {
      field: 'Apr', headerName: 'APR', editable: true, type: 'number', preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'May', headerName: 'MAY', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Jun', headerName: 'JUN', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Jul', headerName: 'JUL', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Aug', headerName: 'AUG', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Sep', headerName: 'SEP', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Oct', headerName: 'OCT', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Nov', headerName: 'NOV', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Dec', headerName: 'DEC', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Jan', headerName: 'JAN', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Feb', headerName: 'FEB', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'Mar', headerName: 'MAR', editable: true, type: 'number',
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
  ];

  const getSelectedValue = (dataToBePassed) => {
    setSelectedFinancialYear(dataToBePassed);
    getAnnualMbrApi(dataToBePassed);
    getStakeholderByTypeApi(dataToBePassed);
    setIsAddMbrBtnDisabled(false);
    setShowBtnOnEditMonths(true);
    setEditUpdateBtnName('Edit Monthly MBR');
    setIsMbrEditable(false);

  }
  const CustomToolbar = () => {
    const exportToExcel = (data) => {
      const ws = XLSX.utils.json_to_sheet(combinedFinalMbrData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Data");
      XLSX.writeFile(wb, "ManageMBR.xlsx");
    };

    return (
      <>
        <Box
          sx={{ p: 0.5, pb: 0, float: 'right' }}>
          <GridToolbarQuickFilter />
        </Box>
        <Box
          sx={{ p: 0.5, pb: 0, float: 'left' }}>
          <Button startIcon={<DownloadIcon />} onClick={() => exportToExcel(combinedFinalMbrData)}>Download</Button>

        </Box>
      </>

    );
  }

  const onConfirmCalculateMonthlyMbr = () => {
    handleCalculateMonthlyMbrDialogClose();
    calculateMonthlyMbrApi();
  }

  const calculateMbrBtn = (e) => {
    handleCalculateMonthlyMbrDialogOpen();
  }

  const updateMbrBtnClick = () => {
    if (editUpdateBtnName === 'Edit Monthly MBR') {
      setEditUpdateBtnName('Save Monthly MBR');
      setIsMbrEditable(true);
      setShowBtnOnEditMonths(false);
      setShowSaveMbrBtn(false);
    } else if (editUpdateBtnName === 'Save Monthly MBR') {
      setEditUpdateBtnName('Edit Monthly MBR');
      arrTemp?.length === 0 && toast.info(DEMAND_CONSTANTS.NoDataUpdated);
      arrTemp?.length !== 0 && updateMonthlyMbrApi();
      setShowBtnOnEditMonths(true)
      setIsMbrEditable(false);
      setShowSaveMbrBtn(true);

    }
  } 

  const addMBRBtnApi = () => {
    setShowSaveMbrBtn(true);
    setShowBtnOnEditMonths(false);
    setShowMonthlyMbrBtn(false);
    let res = [];
    const temp = stakeholderCommonData === null || stakeholderCommonData?.length === 0 ? toast.info(DEMAND_CONSTANTS.NoDataMessage) :
      stakeholderCommonData?.map((data) => {
        let tempData = { ...data }
        return {
          'stakeholderUrn': tempData.urn,
          'stakeholderType': tempData.stakeHolderType,
          'stakeholderMbr': 0
        }
      })
    res = temp?.filter(el => {
      return !combinedFinalMbrData?.find(element => {
        return element.stakeholderUrn === el.stakeholderUrn;
      });
    });
    let finalData = [...res, ...combinedFinalMbrData]
    let newArray = finalData?.filter((ele, ind) => ind === finalData?.findIndex(elem => elem.stakeholderUrn === ele.stakeholderUrn))

    if (newArray?.length !== 0) setIsCalculateMbrBtnDisable(false)
    else setIsCalculateMbrBtnDisable(true)
    setCombinedFinalMbrData(newArray);
  }

  const handleEditableRows = (params) => {
    if (isMbrEditable === true) return (true && params.colDef.field !== "stakeholderMbr")
    else if (isMbrEditable === false) return (params.colDef.field === "stakeholderMbr")
    else return false
  }

  const processRowUpdate = (newRow, oldRow) => {
    const changedField = Object.keys(newRow).find(
      (key) => newRow[key] !== oldRow[key]
    );
    if (changedField === "stakeholderMbr") {
      let data = {
        "financialYear": selectedFinancialYear,
        "stakeholderUrn": newRow.stakeholderUrn,
        "stakeholderType": newRow.stakeholderType,
        "stakeholderMbr": parseFloat(newRow.stakeholderMbr),
      }
     const saveTempArr = [...saveAnnualMBRTemp]
      if (saveTempArr.length !== 0) {
        let filteredData = saveTempArr?.filter(item => item.stakeholderUrn === data.stakeholderUrn)
        if (filteredData.length === 0) saveTempArr.push(data);
        else {
          saveTempArr.map((item) => {
            if (item.stakeholderUrn === data.stakeholderUrn) {
              item.stakeholderMbr = data.stakeholderMbr
            }
          })
        }
      } else { saveTempArr.push(data) }
      setSaveAnnualMBRTemp(saveTempArr)
    } else {
      let data = {
        "financialYear": selectedFinancialYear,
        "stakeholderUrn": newRow.stakeholderUrn,
        "stakeholderType": newRow.stakeholderType,
        "month": changedField,
        "stakeholderMbr": parseFloat(newRow.stakeholderMbr)
      }
      const tempArr = [...arrTemp]
      if (tempArr.length !== 0) {
        let filteredData = tempArr?.filter(item => item.stakeholderUrn === data.stakeholderUrn && item.month === data.month)
        if (filteredData.length === 0) tempArr.push(data);
        else {
          tempArr.map((item) => {
            if (item.stakeholderUrn === data.stakeholderUrn && item.month === data.month) {
              item.stakeholderMbr = data.stakeholderMbr
            }
          })
        }
      } else { tempArr.push(data) }
      setArrTemp(tempArr);
    }
    combinedFinalMbrData.forEach((item) => {
      if (item.stakeholderUrn === newRow.stakeholderUrn) {
        Object.keys(newRow).map((rowItem) => item[rowItem] = newRow[rowItem])
      }
    })
    return newRow
  }

  // -----------------API Calls-------------------

  const getStakeholderByTypeApi = async (dataToBePassed) => {
    loaderService.showLoader();
    await apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        type: 'LLE'
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const dataFromApi = response.data.stakeHolders ? response.data.stakeHolders : []
        const temp = dataFromApi?.map((data) => {
          let tempData = { ...data }
          tempData.stakeHolderType = 'LLE'
          return tempData
        })
        loaderService.hideLoader();
        getStakeholderByTypeGrowerApi(dataToBePassed, temp);
      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getStakeholderByTypeGrowerApi = async (dataToBePassed, lleApiData) => {
    loaderService.showLoader();
    await apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        type: 'Grower'
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const dataFromApi = response.data.stakeHolders ? response.data.stakeHolders : []
        const growerApiData = dataFromApi?.map((data) => {
          let tempData = { ...data }
          tempData.stakeHolderType = 'Grower'
          return tempData
        })
        getStakeholderByTypeHitApi(dataToBePassed, lleApiData, growerApiData);
        loaderService.hideLoader();
      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }
  const getStakeholderByTypeHitApi = async (dataToBePassed, lleApiData, growerApiData) => {
    loaderService.showLoader();
    await apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        type: 'HIT'
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const dataFromApi = response.data.stakeHolders ? response.data.stakeHolders : []
        const hitApiData = dataFromApi?.map((data) => {
          let tempData = { ...data }
          tempData.stakeHolderType = 'HIT'
          return tempData
        })
        getStakeholderByTypeTrnasporterApi(dataToBePassed, lleApiData, growerApiData, hitApiData)
        loaderService.hideLoader();
      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getStakeholderByTypeTrnasporterApi = async (dataToBePassed, lleApiData, growerApiData, hitApiData) => {
    loaderService.showLoader();
    await apiClient.post(GET_APPROVED_STAKEHOLDERS,
      {
        type: 'Transporter'
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const dataFromApi = response.data.stakeHolders ? response.data.stakeHolders : []
        const transporterApiData = dataFromApi?.map((data) => {
          let tempData = { ...data }
          tempData.stakeHolderType = 'Transporter'
          return tempData
        })
        let mergedData = [...transporterApiData, ...lleApiData, ...growerApiData, ...hitApiData]
        setStakeholderCommonData(mergedData);
        loaderService.hideLoader();

      }).catch(function (error) {
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const getAnnualMbrApi = (year) => {
    loaderService.showLoader();
    apiClient.post(GET_ANNUAL_MBR,
      {
        "financialYear": year,
        "userRole": userLoggedIn
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        loaderService.hideLoader();
        getMonthlyMbrApi(year, response.data.lstAnnualMBRVM);
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const getMonthlyMbrApi = (year, annualData) => {
    loaderService.showLoader();
    apiClient.post(GET_MONTHLY_MBR,
      {
        "financialYear": year,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        const response1 = annualData
        const response2 = response.data.mbrLst
        const arr = response1.map((data1) => {
          const matchingData2 = response2?.find((data2) => {
            const data1Id = data1.stakeholderUrn;
            const data2Id = data2.stakeholderUrn;
            return data2Id === data1Id
          });
          return Object.assign({}, data1, matchingData2?.monthlyMBRDict);
        })
        setCombinedFinalMbrData(arr);
        if (arr?.length !== 0) setIsCalculateMbrBtnDisable(false)
        else setIsCalculateMbrBtnDisable(true)
        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const calculateMonthlyMbrApi = () => {
    loaderService.showLoader();
    apiClient.post(CALCULATE_MBR + `?userId=${uuid}`,
      {
        "financialYear": selectedFinancialYear,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        toast.success(response.data.message);
        getAnnualMbrApi(selectedFinancialYear);
        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const updateMonthlyMbrApi = () => {
    loaderService.showLoader();
    apiClient.post(UPDATE_MONTHLY_MBR + `?userId=${uuid}`,
      arrTemp,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        toast.success(response.data.message);
        getAnnualMbrApi(selectedFinancialYear);
        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const onConfirmSaveMonthlyMbr = () => {
    handleSaveMonthlyMbrDialogClose();
    getAnnualMbrApi(selectedFinancialYear);
    setShowBtnOnEditMonths(true);
    setShowMonthlyMbrBtn(true);
    setShowSaveMbrBtn(true);
    loaderService.showLoader();
    apiClient.post(SAVE_ANNUAL_MBR + `?userId=${uuid}`,
      saveAnnualMBRTemp,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
       response.data.isSuccess === true  ? toast.success(response.data.message) : toast.error(response.data.message);
        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const saveAnnualMBRApi = () => {
    if (saveAnnualMBRTemp.length === 0) {
      toast.info(DEMAND_CONSTANTS.NoDataUpdated);
    } else {
      handleSaveMonthlyMbrDialogOpen();
    }
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={12}>
        {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>DEM06</p>}
        <Card style={{ marginBottom: 10 }}>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={2}>
                <FinancialYearDropdown selectedValue={getSelectedValue} />
              </Grid>
              {userLoggedIn === DEMAND_ROLES.DemandPlanner &&
                <Grid item xs={12} lg={10} >
                  <Stack direction="row" spacing={1} style={{ float: 'right' }}>
                    {showBtnOnEditMonths &&
                      <CustomButton startIcon={<CalculateIcon />} title="Calculate Monthly MBR" disabled={isCalculateMbrBtnDisable}
                        onClick={(e) => calculateMbrBtn(e)} />
                    }
                    {showMonthlyMbrBtn && <CustomButton startIcon={<EditIcon />} title={editUpdateBtnName} disabled={isCalculateMbrBtnDisable} onClick={() => updateMbrBtnClick()} />}
                    {showSaveMbrBtn && <CustomButton startIcon={<SaveIcon />} title="Save Annual MBR" disabled={isCalculateMbrBtnDisable} onClick={() => saveAnnualMBRApi()} />}
                    {showBtnOnEditMonths && <Button variant="contained" disabled={isAddMbrBtnDisabled} startIcon={<AddIcon />} onClick={() => addMBRBtnApi()}>Add MBR</Button>}
                  </Stack>
                </Grid>}
            </Grid>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Box sx={{
              height: '300', width: '100%', display: "flex",
              justifyContent: "center",
              alignItems: "center",
              '& .super-app-theme--header': {
                wordWrap: 'break-word',
                wordBreak: 'break-all',
                whiteSpace: 'initial',
              },
              '& .MuiDataGrid-cell--editable': {
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
              },
              '& .Mui-error': {
                                backgroundColor: `rgb(126,10,15,0.1)`,
                                color: (theme) => theme.palette.error.main,
                            },
            }}>
             
                <DataGrid
                  autoHeight
                  columns={columns}
                  rows={combinedFinalMbrData}
                  getRowId={(row) => row?.stakeholderUrn}
                  processRowUpdate={processRowUpdate}
                  isCellEditable={(params) => handleEditableRows(params)}
                  components={{ Toolbar: CustomDataGridToolbar }}
                  componentsProps={{toolbar: {rows: combinedFinalMbrData, columns: columns, fileName: "Final_MBR_Data.xlsx", isExportToExcel: true }}}
                  experimentalFeatures={{ newEditingApi: true }}
                  initialState={{ pinnedColumns: { left: ['stakeholderUrn', 'stakeholderType'] } }}
                  pageSize={pageSize}
                  onPageSizeChange={(newPage) => setPageSize(newPage)}
                />
              
            </Box>
          </CardContent>
        </Card>

      </Grid>
      <ConfirmationPopover onOpen={calculateMonthlyMbrDialog} onConfirm={onConfirmCalculateMonthlyMbr} onClose={handleCalculateMonthlyMbrDialogClose} action="Calculate Monthly Mbr" />
      <ConfirmationPopover onOpen={saveMonthlyMbrDialog} onConfirm={onConfirmSaveMonthlyMbr} onClose={handleSaveMonthlyMbrDialogClose} action="Save Monthly Mbr" />
    </Grid>


  );
}
